export const AFAS_SUB_TAB_KEYS = {
    DAGDELEN: 'dagdelen',
    LANGE_VERZOEKEN: 'lange-verzoeken',
    EXTRA: 'extra',
    OPMERKING_MEMO: 'opmerking-memo',
};

/**
 * Bluebox week filter id for prolonged requests.
 * When selected: show Langdurige verzoeken tab, hide Dagdelen (and vice versa).
 * @see bluebox Salary.js weekSelected == '999999'
 */
export const AFAS_LANGE_VERZOEKEN_WEEK = '999999';

export const isLangeVerzoekenWeek = (week) =>
    String(week) === AFAS_LANGE_VERZOEKEN_WEEK;

export const AFAS_SUB_TABS = [
    { key: AFAS_SUB_TAB_KEYS.DAGDELEN, label: 'Dagdelen' },
    { key: AFAS_SUB_TAB_KEYS.LANGE_VERZOEKEN, label: 'Langdurige verzoeken' },
    { key: AFAS_SUB_TAB_KEYS.EXTRA, label: 'Extra' },
    { key: AFAS_SUB_TAB_KEYS.OPMERKING_MEMO, label: 'Opmerking / Memo' },
];

/** Visible detail tabs depend on week filter (mutual exclusive Dagdelen ↔ Lange). */
export const getVisibleAfasSubTabs = (week) => {
    const hideKey = isLangeVerzoekenWeek(week)
        ? AFAS_SUB_TAB_KEYS.DAGDELEN
        : AFAS_SUB_TAB_KEYS.LANGE_VERZOEKEN;

    return AFAS_SUB_TABS.filter((tab) => tab.key !== hideKey);
};

export const AFAS_VERZOEK_LEFT_FIELDS = [
    { id: 'vervanger', label: 'Vervanger', type: 'text', readOnly: true, col: 'main' },
    { id: 'vervangerMdwNr', label: 'MdwNr', type: 'text', readOnly: true, col: 'inline' },
    { id: 'schoolBrin', label: 'School Brin', type: 'text', readOnly: true },
    { id: 'dagType', label: 'Dag type', type: 'text', readOnly: true },
    { id: 'contractTypeInfo', label: 'Contract Type', type: 'text', readOnly: true },
    { id: 'codeVervanging', label: 'Code vervanging', type: 'text', readOnly: true },
    { id: 'afwezige', label: 'Afwezige', type: 'text', readOnly: true, col: 'main' },
    { id: 'afwezigeMdwNr', label: 'MdwNr', type: 'text', readOnly: true, col: 'inline' },
    { id: 'wtfAfwezige', label: 'WTF afwezige', type: 'text', readOnly: true, col: 'main' },
    { id: 'wtfAfas', label: 'WTF Afas', type: 'text', readOnly: true, col: 'inline' },
    { id: 'verzekeringAfw', label: 'Verzekering afw', type: 'text', readOnly: true },
    { id: 'memoCoordinator', label: 'Memo coordinator', type: 'textarea', readOnly: true, rows: 2 },
    { id: 'memo', label: 'Memo t.b.v. verzoek', type: 'textarea', readOnly: true, rows: 2 },
    {
        id: 'volgnummerDvb',
        label: 'Volgnummer d.v.b.',
        type: 'select',
        placeholder: 'Selecteer dienstverband',
    },
    {
        id: 'vervangerUitPool',
        label: 'Vervanger uit pool',
        type: 'radio',
        options: [
            { value: 'yes', label: 'Ja' },
            { value: 'no', label: 'Nee' },
        ],
    },
    {
        id: 'vervangingsDvb',
        label: 'Vervangings d.v.b.',
        type: 'radio',
        options: [
            { value: 'yes', label: 'Ja' },
            { value: 'no', label: 'Nee' },
        ],
    },
];

export const AFAS_VERZOEK_RIGHT_FIELDS = [
    {
        id: 'vervangt',
        label: 'Vervangt',
        type: 'select',
        placeholder: 'Selecteer wie wordt vervangen',
    },
    {
        id: 'verzuimVerlofId',
        label: 'Verzuim-, verlof-id',
        type: 'select',
        placeholder: 'Selecteer verzuim of verlof',
    },
    {
        id: 'financieringsbron',
        label: 'Financieringsbron',
        type: 'select',
        placeholder: 'Selecteer financieringsbron',
    },
    {
        id: 'kostenplaats',
        label: 'Kostenplaats',
        type: 'select',
        placeholder: 'Selecteer kostenplaats',
    },
    {
        id: 'orgEenheid',
        label: 'Org. Eenheid',
        type: 'select',
        placeholder: 'Selecteer organisatorische eenheid',
    },
    {
        id: 'aardArbeidsrelatie',
        label: 'Aard arbeidsrelatie',
        type: 'select',
        placeholder: 'Selecteer aard arbeidsrelatie',
    },
    {
        id: 'onderwijsinstelling',
        label: 'Onderwijsinstelling',
        type: 'select',
        placeholder: 'Selecteer onderwijsinstelling',
    },
    {
        id: 'dienstbetrekking',
        label: 'Dienstbetrekking',
        type: 'select',
        placeholder: 'Selecteer dienstbetrekking',
    },
    {
        id: 'contractType',
        label: 'Contract Type',
        type: 'select',
        placeholder: 'Selecteer contract type',
    },
    {
        id: 'functieCode',
        label: 'Functie code',
        type: 'select',
        placeholder: 'Selecteer functie code',
    },
    {
        id: 'kostendrager',
        label: 'Kostendrager',
        type: 'select',
        placeholder: 'Selecteer kostendrager',
    },
    {
        id: 'verzekering',
        label: 'Verzekering',
        type: 'select',
        placeholder: 'Selecteer verzekering vervanger',
    },
     {
        id: 'declarerenVf',
        label: 'Declareren VF',
        type: 'radio',
        options: [
            { value: 'yes', label: 'Ja' },
            { value: 'no', label: 'Nee' },
        ],
    },
      {
        id: 'uitbreidingsDvb',
        label: 'Uitbreidings d.v.b.',
        type: 'radio',
        options: [
            { value: 'yes', label: 'Ja' },
            { value: 'no', label: 'Nee' },
        ],
    },
];

export const AFAS_MOCK_VERZOEK = {
    vervanger: 'J. de Vries',
    vervangerMdwNr: '10234',
    schoolBrin: '12AB34 — Basisschool De Horizon',
    codeVervanging: 'Ziekte',
    afwezige: 'P. Jansen',
    afwezigeMdwNr: '8841',
    wtfAfwezige: '1.00000',
    wtfAfas: '1.00000',
    verzekeringAfw: 'WAO',
    memoCoordinator: '',
    memo: '',
    vervangerUitPool: 'no',
    vervangingsDvb: 'yes',
};

export const AFAS_MOCK_REQUEST_GROUPS = [
    {
        id: 'dobbelsteen',
        label: 'Dobbelsteen',
        items: [
            { id: '1', label: 'Basisschool De Dobbelsteen', type: 'school' },
            { id: '2', label: 'M. van Dijk', type: 'person', status: 'open' },
            { id: '3', label: 'S. Bakker', type: 'person', status: 'warning' },
        ],
    },
    {
        id: 'horizon',
        label: 'Horizon',
        items: [
            { id: '4', label: 'Basisschool De Horizon', type: 'school' },
            { id: '5', label: 'J. de Vries', type: 'person', status: 'open', active: true },
            { id: '6', label: 'A. Smit', type: 'person', status: 'open' },
        ],
    },
];

export const AFAS_MOCK_DAGDELEN_ROWS = [
    {
        id: 1,
        datum: '03-06-2026',
        dag: 'Maandag',
        dagdeel: 'Ochtend',
        soortWtf: 'H',
        wtf: '0.50000',
        wtfPerDag: '',
        contractType: 'Vast',
        dagType: 'Normaal',
    },
    {
        id: 2,
        datum: '',
        dag: '',
        dagdeel: 'Middag',
        soortWtf: 'H',
        wtf: '0.50000',
        wtfPerDag: '1.00000',
        contractType: 'Vast',
        dagType: 'Normaal',
    },
    {
        id: 3,
        datum: '04-06-2026',
        dag: 'Dinsdag',
        dagdeel: 'Ochtend',
        soortWtf: 'H',
        wtf: '0.50000',
        wtfPerDag: '',
        contractType: 'Vast',
        dagType: 'Normaal',
    },
];

export const AFAS_DAGDELEN_COLUMNS = [
    { key: 'datum', label: 'Datum' },
    { key: 'dag', label: 'Dag' },
    { key: 'wtfPerDag', label: 'WTF / dag' },
];

export const AFAS_LANGE_VERZOEK_WEEKDAYS = [
    { key: 'monday', label: 'Maandag' },
    { key: 'tuesday', label: 'Dinsdag' },
    { key: 'wednesday', label: 'Woensdag' },
    { key: 'thursday', label: 'Donderdag' },
    { key: 'friday', label: 'Vrijdag' },
];

export const AFAS_DAGDEELGEGEVENS_COLUMNS = [
    { key: 'datum', label: 'Datum' },
    { key: 'dagdeel', label: 'Dagdeel' },
    { key: 'dagType', label: 'Dagtype' },
    { key: 'soortWtf', label: 'Soort WTF' },
    { key: 'wtf', label: 'WTF' },
];

/** Default weekly WTF pattern for langdurige verzoeken (UI stub until API). */
export const createDefaultLangeVerzoekDays = () =>
    AFAS_LANGE_VERZOEK_WEEKDAYS.map((day) => ({
        id: day.key,
        dayKey: day.key,
        dag: day.label,
        wtf: 0,
    }));


export const AFAS_EXTRA_COLUMNS = [
    {
        key: 'left',
        fields: [
            {
                id: 'cao',
                label: 'CAO',
                type: 'select',
                allowEmpty: true,
                options: [],
            },
            {
                id: 'arbeidsvoorwaarde',
                label: 'Arbeidsvoorwaarde',
                type: 'select',
                allowEmpty: true,
                options: [],
            },
            {
                id: 'vervangingBinnenEigenFte',
                label: 'Vervanging binnen eigen FTE',
                type: 'radio',
                options: [
                    { value: 'yes', label: 'Ja' },
                    { value: 'no', label: 'Nee' },
                ],
            },
        ],
    },
    {
        key: 'middle',
        fields: [
            {
                id: 'periodenummerPeriodiek',
                label: 'Periodenummer periodiek',
                type: 'number-stepper',
                min: 1,
                max: 53,
            },
            {
                id: 'periodeVolgendeVerhoging',
                label: 'Periode volgende verhoging',
                type: 'number-stepper',
                min: 201400,
                max: 203000,
            },
            {
                id: 'formatieplaats',
                label: 'Formatieplaats',
                type: 'select',
                allowEmpty: true,
                options: [],
            },
            {
                id: 'bovenschoolseFunctie',
                label: 'Bovenschoolse functie',
                type: 'radio',
                options: [
                    { value: 'yes', label: 'Ja' },
                    { value: 'no', label: 'Nee' },
                ],
            },
        ],
    },
    {
        key: 'right',
        fields: [
            {
                id: 'soortSalaris',
                label: 'Soort salaris',
                type: 'select',
                allowEmpty: true,
                options: [{ value: 'S', label: 'Schaalsalaris' }],
            },
            {
                id: 'functieschaal',
                label: 'Functieschaal',
                type: 'select',
                allowEmpty: true,
                options: [],
            },
            {
                id: 'soortLoonschaal',
                label: 'Soort loonschaal',
                type: 'select',
                allowEmpty: true,
                options: [],
            },
            {
                id: 'loonschaal',
                label: 'Loonschaal',
                type: 'select',
                allowEmpty: true,
                options: [],
            },
            {
                id: 'trede',
                label: 'Trede',
                type: 'select',
                allowEmpty: true,
                options: [],
            },
        ],
    },
];

export const AFAS_MOCK_EXTRA = {
    cao: '',
    arbeidsvoorwaarde: '',
    vervangingBinnenEigenFte: 'no',
    periodenummerPeriodiek: '',
    periodeVolgendeVerhoging: '',
    formatieplaats: '',
    bovenschoolseFunctie: 'no',
    soortSalaris: 'S',
    functieschaal: '',
    soortLoonschaal: '',
    loonschaal: '',
    trede: '',
};

export const AFAS_MOCK_MEMO = {
    memoSalarisadministratie: '',
};

export const AFAS_SYNCHRONISATIE_COLUMNS = [
    { key: 'id', label: 'Id', width: '56px' },
    { key: 'verwerker', label: 'Verwerker' },
    { key: 'week', label: 'Week', width: '64px' },
    { key: 'verzoek', label: 'Verzoek', width: '72px' },
    { key: 'school', label: 'School' },
    { key: 'lijst', label: 'Lijst', width: '100px' },
    { key: 'mdwNrVervanger', label: 'MdwNr' },
    { key: 'vervanger', label: 'Vervanger' },
    { key: 'mdwNrAfwezige', label: 'MdwNr' },
    { key: 'afwezige', label: 'Afwezige' },
    { key: 'aangemaakt', label: 'Aangemaakt' },
    { key: 'status', label: 'Status' },
    { key: 'batchNr', label: 'BatchNr', width: '80px' },
    { key: 'foutmelding', label: 'Foutmelding', width: '100px' },
];

export const AFAS_MOCK_SYNCHRONISATIE_ROWS = [
    {
        id: 1042,
        verwerker: 'J. de Vries',
        week: '23',
        verzoek: '4821',
        school: 'De Dobbelsteen',
        mdwNrVervanger: '10458',
        vervanger: 'M. Jansen',
        mdwNrAfwezige: '9821',
        afwezige: 'P. Bakker',
        aangemaakt: '02-06-2026 09:14',
        status: 'Niet verzonden',
        lijst: 'Automatisch',
        batchNr: '—',
        foutmelding: null,
    },
    {
        id: 1041,
        verwerker: 'S. van Dijk',
        week: '23',
        verzoek: '4819',
        school: 'Horizon',
        mdwNrVervanger: '11002',
        vervanger: 'L. Smit',
        mdwNrAfwezige: '8744',
        afwezige: 'R. Visser',
        aangemaakt: '01-06-2026 16:42',
        status: 'Fout',
        batchNr: 'B-2406',
        foutmelding: 'Medewerker niet gevonden in Profit',
    },
    {
        id: 1040,
        verwerker: 'J. de Vries',
        week: '22',
        verzoek: '4798',
        school: 'De Dobbelsteen',
        mdwNrVervanger: '10311',
        vervanger: 'K. de Boer',
        mdwNrAfwezige: '9012',
        afwezige: 'A. Meijer',
        aangemaakt: '30-05-2026 11:05',
        status: 'Verwerkt',
        batchNr: 'B-2405',
        foutmelding: null,
    },
];

export const AFAS_HISTORIE_COLUMNS = [
    { key: 'id', label: 'Id', width: '56px' },
    { key: 'batchNr', label: 'BatchNr', width: '80px' },
    { key: 'verwerker', label: 'Verwerker' },
    { key: 'week', label: 'Week', width: '64px' },
    { key: 'verzoek', label: 'Verzoek', width: '72px' },
    { key: 'school', label: 'School' },
    { key: 'mdwNrVervanger', label: 'MdwNr' },
    { key: 'vervanger', label: 'Vervanger' },
    { key: 'mdwNrAfwezige', label: 'MdwNr' },
    { key: 'afwezige', label: 'Afwezige' },
    { key: 'aangemaakt', label: 'Aangemaakt' },
    { key: 'verwerktProfit', label: 'Verwerkt Profit' },
];

export const AFAS_MOCK_HISTORIE_ROWS = [
    {
        id: 1038,
        batchNr: 'B-2404',
        verwerker: 'S. van Dijk',
        week: '22',
        verzoek: '4785',
        school: 'Horizon',
        mdwNrVervanger: '10987',
        vervanger: 'T. Hendriks',
        mdwNrAfwezige: '8650',
        afwezige: 'F. Mulder',
        aangemaakt: '28-05-2026 14:22',
        verwerktProfit: '28-05-2026 15:01',
    },
    {
        id: 1037,
        batchNr: 'B-2403',
        verwerker: 'J. de Vries',
        week: '22',
        verzoek: '4772',
        school: 'De Dobbelsteen',
        mdwNrVervanger: '10422',
        vervanger: 'N. Peters',
        mdwNrAfwezige: '9105',
        afwezige: 'E. de Groot',
        aangemaakt: '27-05-2026 10:18',
        verwerktProfit: '27-05-2026 10:45',
    },
    {
        id: 1036,
        batchNr: 'B-2402',
        verwerker: 'J. de Vries',
        week: '21',
        verzoek: '4755',
        school: 'De Dobbelsteen',
        mdwNrVervanger: '10298',
        vervanger: 'B. Willems',
        mdwNrAfwezige: '8891',
        afwezige: 'C. Bos',
        aangemaakt: '22-05-2026 08:55',
        verwerktProfit: '22-05-2026 09:12',
    },
];

export const AFAS_CONFLICT_FILTER_OPTIONS = [
    { value: 'open', label: 'Alle openstaande conflicten' },
    { value: 'resolved', label: 'Opgeloste conflicten' },
    { value: 'all', label: 'Alle conflicten' },
];

export const AFAS_OPENSTAAND_FILTER_OPTIONS = [
    { value: 'all', label: 'Alle' },
    { value: 'open', label: 'OK' },
    { value: 'warning', label: 'Waarschuwing' },
    { value: 'error', label: 'Fout' },
];

/** Footer Verzendwijze — how to process the selected verzoek (port bluebox modus). */
export const AFAS_SUBMIT_MODE_OPTIONS = [
    { value: 'auto', label: 'Automatisch' },
    { value: 'hand', label: 'Handmatig' },
    { value: 'afmelden', label: 'Afmelden' },
];

/** Sidebar list filter — auto vs hand queue (port bluebox left filter). */
export const AFAS_LIST_MODE_OPTIONS = [
    { value: 'auto', label: 'Automatisch' },
    { value: 'hand', label: 'Handmatig' },
];

export const AFAS_CONFLICTEN_COLUMNS = [
    { key: 'verbergen', label: 'Verbergen?', width: '88px' },
    { key: 'bsn', label: 'BSN', width: '100px' },
    { key: 'naam', label: 'Naam' },
    { key: 'huidigeWaarde', label: 'Huidige waarde' },
    { key: 'gekozenWaarde', label: 'Gekozen waarde' },
    { key: 'reden', label: 'Reden / Opmerking' },
];

export const AFAS_MOCK_CONFLICTEN_ROWS = [
    {
        id: 1,
        verbergen: false,
        bsn: '123456782',
        naam: 'M. Jansen',
        huidigeWaarde: 'LB 6',
        gekozenWaarde: 'LB 7',
        gekozenOpties: [
            { value: 'LB 6', label: 'LB 6' },
            { value: 'LB 7', label: 'LB 7' },
            { value: 'LB 8', label: 'LB 8' },
        ],
        reden: 'Trede gewijzigd na herindeling',
        resolved: false,
    },
    {
        id: 2,
        verbergen: false,
        bsn: '987654321',
        naam: 'P. Bakker',
        huidigeWaarde: 'Horizon',
        gekozenWaarde: 'De Dobbelsteen',
        gekozenOpties: [
            { value: 'Horizon', label: 'Horizon' },
            { value: 'De Dobbelsteen', label: 'De Dobbelsteen' },
        ],
        reden: 'Schoolnaam afwijkend in Profit',
        resolved: false,
    },
    {
        id: 3,
        verbergen: true,
        bsn: '456789123',
        naam: 'L. Smit',
        huidigeWaarde: '10458',
        gekozenWaarde: '11002',
        gekozenOpties: [
            { value: '10458', label: '10458' },
            { value: '11002', label: '11002' },
        ],
        reden: 'MdwNr conflict opgelost',
        resolved: true,
    },
];
